export default "__VITE_ASSET__WlO0L99j__"